@let name = nameSg();
@let active = activeSg();
@let navbarIsExpanded = store.expandedSg();
@let expandedAppIds = store.expandedAppIdsSg();
@let app = appSg();
<a
  class="atn-navbar-app-list-item"
  [class.atn-navbar-app-list-item--active]="active"
  [atnPlatformNavigationLink]="urlSg()"
  [attr.data-test-id]="'sidebar-' + name + '-button'"
  (click)="app ? store.toggleAppExpanded(app.id) : undefined"
>
  <span>
    <i
      class="atn-navbar-app-list-item__icon atn-icon atn-{{
        iconSg()
      }} atn-light atn-{{ active ? 'active' : 'inactive' }}"
    ></i>
    <span
      class="atn-navbar-app-list-item__name"
      [class.atn-navbar-app-list-item__name--hidden]="!navbarIsExpanded"
      [atnDsEllipsisTooltip]="name"
    >
      {{ name }}
    </span>
  </span>

  @if (app && navbarIsExpanded) {
    @let appIsExpanded = !!app.id && expandedAppIds.has(app.id);

    <span class="atn-navbar-app-list-item__triangle">
      <i
        class="atn-navbar-app-list-item__triangle-icon atn-icon atn-triangle-{{
          appIsExpanded ? 'down' : 'left'
        }} atn-light"
      ></i>
    </span>
  }
</a>
@if (app && expandedAppIds.has(app.id)) {
  <div
    class="atn-navbar-app-list-item__pages"
    [class.atn-navbar-app-list-item__pages--hidden]="!navbarIsExpanded"
    data-test-id="pages-list"
  >
    @for (appPage of app.pages; track appPage.id) {
      @if (appPage.display?.isMain) {
        <a
          class="atn-navbar-app-list-item__page-item"
          [class.atn-navbar-app-list-item__page-item--active]="
            meFeature.contexts.selectors
              .isCurrentlyOnAppPage(appPage)
              .asSignal()
          "
          [atnPlatformNavigationLink]="
            meFeature.contexts.selectors
              .getUrlForLink({ goto: { navigationId: appPage.alias } }, { app })
              .asSignal()
          "
        >
          {{ appPage.name }}
        </a>
      }
    }
    @let appsWithUtilityPages = appsWithUtilityPagesSg();
    @if (appsWithUtilityPages.has(app.id)) {
      <atn-navbar-app-utilities [app]="app" />
    }
  </div>
}
